import React, {useEffect} from "react";
import Check from "@mui/icons-material/Check";
import Warning from "@mui/icons-material/Warning";
import SnackbarContent from "../Snackbar/SnackbarContent";
import {useUserVerifyRequest} from "../../request/api";

export default function VerifyGenericUser({ hash }) {
  const { error, isMutating, trigger: confirmAccount } = useUserVerifyRequest({ key: hash });

  useEffect(() => {
    if (!hash) return;
    confirmAccount().catch((e) => {
      console.warn(e);
    });
  }, [hash, confirmAccount]);

  if (!hash || isMutating) {
    return <strong>Loading...</strong>;
  }

  if (error) {
    return (
      <SnackbarContent
        message={error.response?.data?.message ??
          "Sorry, something went wrong. Please get in touch with us to resolve."}
        color="warning"
        icon={Warning}
      />
    );
  }

  return (
    <SnackbarContent
      message={
        <>
          Your account details have been submitted to our admin for approval.
          We'll email you to let you know as soon as your account has been approved and you can log in to the site.
          Please note, it can take up to 24 hours to approve an account.
        </>
      }
      color="success"
      icon={Check}
    />
  );
}
